module.exports = __webpack_public_path__ + "static/Karim.140e98fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Karim.jpg
// module id = 1304
// module chunks = 137408898365125